export default __webpack_public_path__ + "static/Rubixcube-e96defe4a9578931800885091770bfc9.webp";